export default "__VITE_ASSET__Bb2CZMYJ__"